<p-card
	[header]="
		'presentation.app.page.profile.coach.references.certificates.header'
			| translate
	"
>
	<div class="space-y-3">
		<div *ngFor="let certificate of certificates">
			<span class="text-xs underline-none">
				{{ certificate.startDate | date: 'MM/yyyy' }} -
				{{ certificate.endDate | date: 'MM/yyyy' }} :
			</span>
			<span class="font-semibold">
				{{ certificate.name }}, {{ certificate.institution }}
			</span>
		</div>
	</div>
</p-card>
